export const flattenMessages = (
    nestedMessages: Record<string, any>,
    prefix = ""
  ): Record<string, string> => {
    return Object.keys(nestedMessages).reduce((messages, key) => {
      const value = nestedMessages[key];
      const prefixedKey = prefix ? `${prefix}.${key}` : key;
  
      if (typeof value === "object" && value !== null) {
        Object.assign(messages, flattenMessages(value, prefixedKey));
      } else {
        messages[prefixedKey] = value;
      }
  
      return messages;
    }, {} as Record<string, string>);
  };
  